import SimilarEmbed from "./components/SimilarEmbed.vue";
import RecentEmbed from "./components/RecentEmbed.vue";
import Vue from "vue";

export default {
  methods: {
    enabledOnPage: function (key) {

      let pages = this[key][0].split(",");

      let isAllowed = false;
      let blacklisted = [];
      if (key == 'productdetails' && window.location.host == "tonykealys.com") {
        pages = [".product", ".product-visualconstructor"];
      }
      for (const page of pages) {
        if (page.startsWith("!")) {
          blacklisted.push(page.split("!")[1]);
        }
      }

      for (let page of pages) {
        if (page == "*") {
          isAllowed = true;
        }
        // CUSTOM FIX GREENESSHOES
        if (key == 'productdetails' && window.location.host == 'greenesshoes.com') {
          page = 'body' + page
        }

        if (
          document.querySelector(page) ||
          (page.startsWith("/") && window.location.href.indexOf(page) != -1)
        ) {
          isAllowed = true;
        }
      }
      if (blacklisted.length > 0) {
        for (const page of blacklisted) {
          if (
            document.querySelector(page) ||
            (page.startsWith("/") && window.location.href.indexOf(page) != -1)
          ) {
            isAllowed = false;
          }
        }
      } if (key == 'homepage') {
        // console.log(isAllowed)

      }

      return isAllowed;
    },
    isMobile: function () {
      if (window.innerWidth <= 640) {
        return true;
      } else {
        return false;
      }
    },
    getDeviceType: function (vm) {
      const ua = navigator.userAgent;
      let device = null;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        device = "tablet";
      } else if (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        device = "mobile";
      } else {
        device = "desktop";
      }

      vm.$store.dispatch("emitEvent", {
        data: {
          page: device,
          productid: "",
          sbAction: "Device",
          site: vm.$store.state.client,
          source: "Device",
          uuid: vm.$store.state.uuid,
        },
        headers: {},
        type: "sbaction",
      });
    },
    generateUuid: function () {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
      ) {
        let r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    checkClassAndId: function (el, val) {
      let val_stripped = val.substring(1).split(" ")[0];
      return (
        el.classList.contains(val_stripped) ||
        el.classList.contains("sb-item") ||
        el.id == val_stripped
      );
    },
    checkTagName: function (el, tag) {
      return el.tagName.toLowerCase() == tag;
    },
    checkForParent: function (el, parent) {
      let firstLetter = parent.charAt(0);
      if (firstLetter == "." || firstLetter == "#") {
        return this.checkClassAndId(el, parent);
      } else {
        return this.checkTagName(el, parent);
      }

    },
    detectSku: function (deltaX, deltaY) {
      let x = deltaX;
      let y = deltaY;
      const { parent, reach, className, attr } = this.searchConfig;
      // console.log(this.searchConfig)
      let parents = []
      let final_sku;
      if (parent.toString().indexOf(',')) {
        parents = [...parent.split(',')]
      } else {
        parents.push(...parent)
      }
      console.log(parents)
      parents.forEach(p => {
        // console.log(p)
        let el = document.elementFromPoint(x, y);
        let i = 0;

        while (!el.URL && !this.checkForParent(el, p) && i < reach) {
          if (el.tagName == "HTML") {
            break;
          }
          // console.log('dropped on:', el, i);
          el = el.parentNode ? el.parentNode : el;
          i += 1;
        }

        i = 0;
        // console.log('final element :', el);
        let temp_search_config = {
          parent: p,
          className: className,
          attr: attr
        }

        if (this.returnSku(el, temp_search_config)) {
          if (!final_sku) {
            final_sku = el.tagName != "HTML"
              ? this.returnSku(el, temp_search_config)
              : null;
          }
        }

      })

      return final_sku
      // return el.tagName != "HTML"
      //   ? this.returnSku(el, this.searchConfig)
      //   : null;
    },
    returnSku(el, searchConfig) {

      const { className, parent, attr } = searchConfig;
      let skuElement;
      let stripped_class = className.substring(1);
      let stripped_parent = parent.substring(1);

      let sku = "";

      if (stripped_class == stripped_parent && attr) {
        skuElement = el;
        if (el.classList.contains("sb-item")) {
          skuElement.setAttribute(
            `${attr}`,
            el.querySelector(".sb-sku").innerText
          );
        }
      } else {
        skuElement = el.querySelector(className)
          ? el.querySelector(className)
          : el.querySelector(".sb-sku");
      }



      if (attr && !skuElement.classList.contains("sb-sku")) {
        sku = skuElement.getAttribute(attr);
        if (sku) {
          if (attr == "href") {
            if (window.location.host == "www.interflora.es") {
              sku = sku.split("#")[0];
            }

            let skuArr = sku.split("?")[0].split('/').filter(x => x != '')
            sku = skuArr[skuArr.length - 1]
              .replace('.html', '')
              .replace(/^.*\/\/[^/]+/, "")
              .replace(/[^\w]/g, "")
              .replace(/_/g, "");
          }
        }
      } else {
        sku = skuElement.innerText;
      }
      return sku;
    },
    detectDetailsFilter(filter) {
      let { name, selector, data } = filter;
      const allFilters = document.querySelectorAll(selector);
      Array.from(allFilters).forEach((element) => {
        element.addEventListener("click", (event) =>
          this.changeDetailsFilter(name, event, data)
        );
      });
    },
    getDetailsFilterData(data, el) {
      if (data == "value") {
        return el.value;
      }
      if (data == "text") {
        return el.innerText;
      }
      if (el.includes(data)) {
        return el.getAttribute(data);
      }
    },
    changeDetailsFilter(name, event, data) {
      let currentFilterName = `shopbox_filter_${name}`;
      let currentFilterData = {
        name: name,
        data: this.getDetailsFilterData(data, event.target),
      };
      if (!sessionStorage.getItem(currentFilterName)) {
        sessionStorage.setItem(
          currentFilterName,
          JSON.stringify(currentFilterData)
        );
      } else {
        let prevData = JSON.parse(sessionStorage.getItem(currentFilterName));
        Object.keys(currentFilterData).forEach(function (val) {
          prevData[val] = currentFilterData[val];
        });
        sessionStorage.setItem(currentFilterName, JSON.stringify(prevData));
      }
    },
    getDetailsFilterNames() {
      return Object.keys(sessionStorage).filter((x) =>
        x.includes("shopbox_filter")
      );
    },
    getDetailsFilters() {
      let filterNames = this.getDetailsFilterNames();
      let filters = [];
      filterNames.forEach((name) => {
        filters.push(sessionStorage.getItem(name));
      });
      return filters;
    },
    routerChange(vm) {
      // Update current page in state every 500ms
      setInterval(function () {
        if (
          vm.$store.state.c_page == null ||
          vm.$store.state.c_page != window.location.pathname
        ) {
          // vm.checkEnabled()
          // page has changed, set new page as 'current'
          vm.$store.commit("SET_C_PAGE", window.location.pathname);
          vm.closePanels();
          // Page load event
          // vm.$store.dispatch("emitEvent", {
          //   data: {
          //     page: vm.$store.state.c_page,
          //     productid: "",
          //     sbAction: "Page",
          //     site: vm.$store.state.client,
          //     source: "PageLoad",
          //     uuid: vm.$store.state.uuid,
          //   },
          //   headers: {},
          //   type: "sbaction",
          // });
        }
      }, 1000);
    },
    cartCheck(vm) {
      let productList = Array.from(document.querySelectorAll(`${vm.parent}`));
      for (const product of productList) {
        let productNodes = product.querySelectorAll(`${vm.parent} *`);
        let sku = Array.from(productNodes).filter(
          (child) => child.classList && child.classList.contains(vm.identifier)
        )[0].innerText;
        if (!vm.$store.state.cart.includes(sku)) {
          vm.$store.state.cart.push(sku);
        }
      }
      if (
        vm.$store.state.cart.length > 0 &&
        (!vm.$store.state.crosssellOpen || !vm.$store.state.ctaOpen)
      ) {
        vm.toggleCrosssellCTA();
        vm.$store.state.crosssellWasClosed = true;
      }
    },
    trackCartPage(vm) {
      let ran = false;
      if (vm.enabledOnPage("cartpage") && !ran) {
        //  window.cartInterval = setInterval(() => this.cartCheck(vm), 1000);
        this.cartCheck(vm);
        ran = true;
      } else {
        ran = false;
        clearInterval(window.cartInterval);
        vm.$store.state.crosssellWasClosed = false;
        vm.$store.state.crosssellOpen = false;
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
      }
      return (false);
    },
    setShopboxAdmin() {
      let val = this.getQueryVariable("shopbox")
      if (val) {
        localStorage.setItem("shopboxAdmin", val);
      }
    },
    observeCurrency(targetSelector) {
      const currencyDict = {
        '£{{amount}}': '£',
        GBP: '£',
        AED: 'Dhs.',
        AUD: 'A$',
        CAD: 'CA$',
        EUR: '€',
        NZD: 'NZ$',
        USD: '$',
      }
      let currencyKeys = Object.keys(currencyDict)
      let target = document.querySelector(targetSelector);

      let currencySymbol;
      let currencyCode;
      if (target) {
        for (let code of currencyKeys) {
          if (targetSelector == '#CurrencyData') {
            if (target.getAttribute('data-money-currency-format').indexOf(code) !== -1) {
              currencySymbol = currencyDict[code]
              currencyCode = code
            }

          } else {

            if (target.innerText.indexOf(code) !== -1) {
              currencySymbol = currencyDict[code]
              currencyCode = code
            }
          }
        }
        if (currencyCode == '£{{amount}}') {
          currencySymbol = '£'
          currencyCode = 'GBP'
        }
        if (currencySymbol) {
          this.$store.commit("SET_CURRENCY", currencySymbol);

        } if (currencyCode) {

          this.$store.commit("SET_CURRENCY_CODE", currencyCode);
        }
      }
    },
    embedSimilarPanel(store, color, sku, similarembedselector) {
      if (!document.querySelector('.sb-similar-panel') && document.querySelector(similarembedselector)) {
        const wrap = document.createElement("div");
        wrap.classList.add("sb-similar-panel");
        if (window.location.host == "tonykealys.com") {
          console.log('220')
          if (document.querySelector('body.product')) {
            console.log('221')
            document.querySelector(similarembedselector).after(wrap);
          } else {
            console.log('22')
            document.querySelector('.product-single__description').after(wrap);
          }
        } else {
          document.querySelector(similarembedselector).after(wrap);
        }
        const componentInstance = new Vue(
          Object.assign({}, SimilarEmbed, {
            propsData: {
              store: store,
              color: color,
              sku: sku,
            },
          })
        );
        componentInstance.$mount(wrap);
      }
    },
    embedRecentPanel(store, color, recentembedselector) {
      setTimeout(() => {
        if (!document.querySelector('.sb-recent-panel') && document.querySelector(recentembedselector)) {
          console.log('pp', recentembedselector);
          const wrap = document.createElement("div");
          wrap.classList.add("sb-recent-panel");
          document.querySelector(recentembedselector).after(wrap);
          const componentInstance = new Vue(
            Object.assign({}, RecentEmbed, {
              propsData: {
                store: store,
                color: color,
              },
            })
          );
          componentInstance.$mount(wrap);
        }
      }, 120)

    },
  }
}
